import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { RiMapPinLine, RiArrowDownLine, RiArrowUpLine } from "react-icons/ri";
import { FaRegCalendarCheck } from "react-icons/fa";
import { useEffect, useState } from "react";
import { getParkingLocationsAPI } from "../../services/Networkcall";
import AlertTypes from "../../components/alertPrefernces/AlertTypes";
import { MdInfoOutline } from "react-icons/md";
import { GoTag } from "react-icons/go";
import { Loader } from "../../components/common/Loader";
import { errorAlert, successAlert } from "../../components/common/Alert";

export const LocationsPricing = () => {

    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchParkingLocations = async () => {
        setLoading(true);
        try {
            const res = await getParkingLocationsAPI();
            if (res?.status) {
                setLocations(res?.data || []);
            }
            else {
                errorAlert({ message: res?.message || "Something went wrong." });
            }
        }
        catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Something went wrong." });
        }
        finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        fetchParkingLocations();
    }, [])

    const openMap = (url) => {
        window.open(url, "_blank");
    };


    const getOldPrice = (pricedata) => {
        const oldprice = pricedata?.price || 0;
        const overridePrice = pricedata?.overridePrice || 0;
        if (oldprice === overridePrice) { return null; }
        return (
            <>
                <div className="old-price">  ${oldprice}  </div>
                <div className="new-price">
                    {overridePrice < oldprice ? <RiArrowDownLine /> : <RiArrowUpLine color="red" />}
                </div>
            </>
        );
    };

    return (
        <>
            <Loader show={loading} />
            <Container fluid className="lp-container">

                {/* HEADER */}
                <div className="lp-header-row">

                    <div>
                        <h3>Locations & Pricing</h3>
                        <p>Compare availability and pricing across all locations.</p>
                    </div>

                    <div className="price-info">
                        <MdInfoOutline size={25} color="#0d2c6c" />
                        <div>
                            <span>All prices in USD</span>
                            <small>Taxes may apply</small>
                        </div>
                    </div>

                </div>

                {/* TABLE */}
                <div className="lp-table-wrapper">

                    <Table responsive className="lp-table">
                        <thead>
                            <tr>
                                <th>LOCATION NAME</th>
                                <th>ADDRESS</th>
                                <th>GOOGLE MAPS</th>
                                <th>AVAILABILITY</th>
                                <th>DAY PRICE</th>
                                <th>WEEKLY PRICE</th>
                                <th>MONTHLY PRICE</th>
                                <th>SUBSCRIPTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {locations?.length > 0 ?
                                locations.map((location, i) => (
                                    <tr key={i}>

                                        {/* LOCATION */}
                                        <td>
                                            <div className="lp-location">
                                                <div className="lp-logo">
                                                    <img src={location?.locationImage || "assets/images/imageplaceholder.png"} width={50} height={50} className="object-fit-fill" />
                                                </div>
                                                <div>
                                                    <strong>{location?.locationName}</strong>
                                                    {/* <p>{item.city}</p> */}
                                                </div>
                                            </div>
                                        </td>

                                        {/* ADDRESS */}
                                        <td>
                                            <div className="lp-address">
                                                {/* <RiMapPinLine className="icon" /> */}
                                                <RiMapPinLine size={35} color={"#2563eb"} />
                                                <p>{location?.locationAddress}</p>
                                            </div>
                                        </td>

                                        {/* MAP */}
                                        <td>
                                            <button className="map-btn text-nowrap rounded border" onClick={() => openMap(location?.locationUrl)}>
                                                <RiMapPinLine size={15} className="me-1" />
                                                View Map
                                            </button>
                                        </td>

                                        {/* AVAILABILITY */}
                                        <td>
                                            <div className="lp-availability">
                                                <FaRegCalendarCheck />
                                                {location?.avaliableSlots > 0 ? location?.avaliableSlots : 0}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="price-box">
                                                {getOldPrice(location?.location_price[0]?.dayPrice)}
                                                <span>${location?.location_price[0]?.dayPrice?.overridePrice || 0}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="price-box">
                                                {getOldPrice(location?.location_price[0]?.weeklyPrice)}
                                                <span>${location?.location_price[0]?.weeklyPrice?.overridePrice || 0}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="price-box">
                                                {getOldPrice(location?.location_price[0]?.monthlyPrice)}
                                                <span>${location?.location_price[0]?.monthlyPrice?.overridePrice || 0}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="price-box">
                                                {getOldPrice(location?.location_price[0]?.monthlySubscriptionPrice)}
                                                <span>${location?.location_price[0]?.monthlySubscriptionPrice?.overridePrice || 0}</span>
                                            </div>
                                        </td>

                                    </tr>
                                )) :
                                <tr>
                                    <td colSpan={12} className="text-center py-4">
                                        No Record Found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </div>

                <div className="price-note">
                    <span className="note-icon"><GoTag color="green" strokeWidth={1.3} /></span>
                    Green down arrow indicates a discounted price.
                </div>

            </Container>
        </>
    );
}